// ============================================================
//  SiteHeader — Enhanced header with tab management and editing
// ============================================================

import React from 'react';
import type { HeaderState } from '../../../types/index';
import { DynamicTabHeader } from '../components/DynamicTabHeader';
import './SiteHeader.css';

interface Props {
  header: HeaderState;
  activePage: string;
  isSelected: boolean;
  onSelect: () => void;
  onSwitchPage: (pid: string) => void;
}

export function SiteHeader({
  header,
  activePage,
  isSelected,
  onSelect,
  onSwitchPage,
}: Props): React.ReactElement {
  return (
    <div>
      <div
        className={`site-header-container ${isSelected ? 'selected' : ''}`}
        onClick={(e) => {
          e.stopPropagation();
          onSelect();
        }}
        style={{
          backgroundColor: header.bgImageSrc
            ? 'transparent'
            : header.bgColor || '#ffffff',
          backgroundImage: header.bgImageSrc
            ? `linear-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.1)), url(${header.bgImageSrc})`
            : 'none',
          backgroundSize: header.bgSize || 'cover',
          backgroundPosition: header.bgPosition || 'center',
          backgroundRepeat: header.bgRepeat || 'no-repeat',
          height: header.height ? `${header.height}px` : 'auto',
          color: header.textColor || '#1a1917',
          borderBottom: '1px solid #e2e1d8',
          padding: '16px 0',
          cursor: 'pointer',
          position: 'relative',
          ...(isSelected && {
            outline: '2px solid #2563eb',
            outlineOffset: '2px',
            backgroundColor: header.bgImageSrc ? 'transparent' : '#f8fafc',
            backgroundImage: header.bgImageSrc
              ? `linear-gradient(rgba(248,250,252,0.9), rgba(248,250,252,0.9)), url(${header.bgImageSrc})`
              : 'none',
          }),
        }}
      >
        {/* Header Content */}
        <div style={{ padding: '0 32px', marginBottom: '12px' }}>
          {header.logoType === 'text' && header.logoText && (
            <h1
              style={{
                fontSize: `${header.fontSize}px`,
                fontFamily: header.fontFamily,
                fontWeight: header.fontWeight,
                textAlign: header.textAlign,
                margin: '0 0 12px 0',
                color: 'inherit',
              }}
            >
              {header.logoText}
            </h1>
          )}

          {header.logoType === 'image' && header.logoImageSrc && (
            <div
              style={{
                marginBottom: '12px',
                textAlign: header.textAlign,
              }}
            >
              <img
                src={header.logoImageSrc}
                alt="Logo"
                style={{
                  height: 40,
                  objectFit: header.logoObjectFit || 'contain',
                }}
              />
            </div>
          )}
        </div>

        {/* Selection Indicator */}
        {isSelected && (
          <div
            style={{
              position: 'absolute',
              top: '-8px',
              right: '8px',
              background: '#2563eb',
              color: 'white',
              padding: '4px 8px',
              borderRadius: '4px',
              fontSize: '12px',
              fontWeight: '600',
              pointerEvents: 'none',
            }}
          >
            ✏️ Header sélectionné
          </div>
        )}
      </div>
      {/* Dynamic Tabs */}
      <div onClick={(e) => e.stopPropagation()}>
        <DynamicTabHeader header={header} onSwitchPage={onSwitchPage} />
      </div>
    </div>
  );
}
